import { useState, useRef } from 'react';

const ALL_PARTS = [
  'Motor',
  'Motor Yedek Parçaları',
  'Şanzıman',
  'Diferansiyel',
  'Hidrolik',
  'Elektrik Aksamı',
  'Filtreler',
  'Radyatör',
  'Jant & Şaft',
  'PİN',
  'Ataşman',
  'Kazıcı',
  'Yükleyici',
  'Kabin',
];

const brands = [
  { id: 1,  name: 'KOMATSU',     country: 'Japonya',   logo: 'https://ilkeismakinalari.com/img/komatsu.png',    parts: ALL_PARTS },
  { id: 2,  name: 'CAT',         country: 'ABD',        logo: 'https://ilkeismakinalari.com/img/cat.png',        parts: ALL_PARTS },
  { id: 3,  name: 'HITACHI',     country: 'Japonya',   logo: 'https://ilkeismakinalari.com/img/hitachi.png',    parts: ALL_PARTS },
  { id: 4,  name: 'VOLVO',       country: 'İsveç',     logo: 'https://ilkeismakinalari.com/img/volvo.png',      parts: ALL_PARTS },
  { id: 5,  name: 'LIEBHERR',    country: 'Almanya',   logo: 'https://ilkeismakinalari.com/img/liebherr.png',   parts: ALL_PARTS },
  { id: 6,  name: 'HİDROMEK',    country: 'Türkiye',   logo: 'https://ilkeismakinalari.com/img/hidromek.png',   parts: ALL_PARTS },
  { id: 7,  name: 'JCB',         country: 'İngiltere', logo: 'https://ilkeismakinalari.com/img/jcb.png',        parts: ALL_PARTS },
  { id: 8,  name: 'CASE',        country: 'ABD',        logo: 'https://ilkeismakinalari.com/img/case.png',       parts: ALL_PARTS },
  { id: 9,  name: 'NEW HOLLAND', country: 'İtalya',    logo: 'https://ilkeismakinalari.com/img/newholland.png', parts: ALL_PARTS },
  { id: 10, name: 'HYUNDAI',     country: 'G. Kore',   logo: 'https://ilkeismakinalari.com/img/hyundai.png',    parts: ALL_PARTS },
  { id: 11, name: 'DOOSAN',      country: 'G. Kore',   logo: 'https://ilkeismakinalari.com/img/doosan.png',     parts: ALL_PARTS },
  { id: 12, name: 'KUBOTA',      country: 'Japonya',   logo: 'https://ilkeismakinalari.com/img/kubota.png',     parts: ALL_PARTS },
  { id: 13, name: 'BOBCAT',      country: 'ABD',        logo: 'https://ilkeismakinalari.com/img/bobcat.png',     parts: ALL_PARTS },
  { id: 14, name: 'DANA',        country: 'ABD',        logo: 'https://ilkeismakinalari.com/img/dana.png',       parts: ['Şanzıman', 'Diferansiyel'] },
  { id: 15, name: 'CARRARO',     country: 'İtalya',    logo: 'https://ilkeismakinalari.com/img/carraro.png',    parts: ['Şanzıman', 'Diferansiyel'] },
  { id: 16, name: 'ZF',          country: 'Almanya',   logo: 'https://ilkeismakinalari.com/img/zf.png',         parts: ['Şanzıman', 'Diferansiyel'] },
  { id: 17, name: 'CUMMINS',     country: 'ABD',        logo: 'https://ilkeismakinalari.com/img/cummins.png',    parts: ['Motor', 'Motor Yedek Parçaları'] },
  { id: 18, name: 'KAWASAKI',    country: 'Japonya',   logo: 'https://ilkeismakinalari.com/img/kawasaki.png',   parts: ALL_PARTS },
];

const partIcons: Record<string, string> = {
  'Motor':                 'ri-settings-3-line',
  'Motor Yedek Parçaları': 'ri-tools-line',
  'Şanzıman':              'ri-settings-4-line',
  'Diferansiyel':          'ri-git-branch-line',
  'Hidrolik':              'ri-drop-line',
  'Elektrik Aksamı':       'ri-flashlight-line',
  'Filtreler':             'ri-filter-3-line',
  'Radyatör':              'ri-temp-hot-line',
  'Jant & Şaft':           'ri-steering-2-line',
  'PİN':                   'ri-pushpin-line',
  'Ataşman':               'ri-attachment-line',
  'Kazıcı':                'ri-tools-fill',
  'Yükleyici':             'ri-truck-line',
  'Kabin':                 'ri-home-gear-line',
};

export default function Brands() {
  const [activeId, setActiveId] = useState<number | null>(null);
  const panelRef = useRef<HTMLDivElement>(null);

  const activeBrand = brands.find((b) => b.id === activeId) ?? null;

  const handleSelect = (id: number) => {
    if (activeId === id) {
      setActiveId(null);
      return;
    }
    setActiveId(id);
    setTimeout(() => {
      panelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 80);
  };

  return (
    <section id="markalar" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-orange-500"></div>
              <span className="text-orange-500 text-xs font-bold tracking-[0.3em] uppercase">
                Tedarik Ettiğimiz Markalar
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 leading-tight">
              DÜNYA DEVLERİYLE
              <br />
              <span className="text-orange-500">ÇALIŞIYORUZ</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-xs text-sm leading-relaxed">
            18 dünya markası için yedek parça tedariki yapıyoruz.{' '}
            <span className="text-orange-500/80">Markaya tıklayın</span>, parça gruplarını görün.
          </p>
        </div>

        {/* Brand Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-6 gap-px bg-gray-200">
          {brands.map((brand) => {
            const isActive = activeId === brand.id;
            return (
              <button
                key={brand.id}
                onClick={() => handleSelect(brand.id)}
                className={`
                  group relative flex flex-col items-center justify-center gap-3 p-5 md:p-6
                  transition-all duration-200 cursor-pointer focus:outline-none
                  ${isActive
                    ? 'bg-orange-50'
                    : 'bg-white hover:bg-gray-50'
                  }
                `}
              >
                {/* Active indicator top bar */}
                <div className={`absolute top-0 left-0 right-0 h-[2px] transition-all duration-200 ${isActive ? 'bg-orange-500' : 'bg-transparent'}`} />

                {/* Logo */}
                <div className="w-24 h-14 flex items-center justify-center">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-w-full max-h-full object-contain transition-all duration-300"
                    style={{
                      filter: isActive
                        ? 'drop-shadow(0 0 6px rgba(249,115,22,0.3))'
                        : 'none',
                      opacity: isActive ? 1 : 0.75,
                    }}
                  />
                </div>

                {/* Name */}
                <span className={`text-[10px] font-black tracking-widest uppercase transition-colors duration-200 ${isActive ? 'text-orange-500' : 'text-gray-400 group-hover:text-gray-600'}`}>
                  {brand.name}
                </span>

                {/* Arrow indicator when active */}
                {isActive && (
                  <div className="absolute bottom-[-1px] left-1/2 -translate-x-1/2 w-0 h-0"
                    style={{
                      borderLeft: '8px solid transparent',
                      borderRight: '8px solid transparent',
                      borderTop: '8px solid rgb(255,247,237)',
                    }}
                  />
                )}
              </button>
            );
          })}
        </div>

        {/* Parts Panel */}
        <div
          ref={panelRef}
          className={`overflow-hidden transition-all duration-300 ${activeBrand ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0'}`}
        >
          {activeBrand && (
            <div className="bg-white border border-gray-200 border-t-2 border-t-orange-500 p-6 md:p-8">

              {/* Panel header */}
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                <div className="flex items-center gap-4">
                  <div className="w-24 h-14 flex items-center justify-center shrink-0">
                    <img
                      src={activeBrand.logo}
                      alt={activeBrand.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-0.5">
                      <span className="text-orange-500 text-[10px] font-bold tracking-[0.3em] uppercase">
                        Tedarik Ettiğimiz Parça Grupları
                      </span>
                    </div>
                    <h3 className="text-gray-900 text-2xl font-black leading-none">
                      {activeBrand.name}
                    </h3>
                    <div className="flex items-center gap-3 mt-1">
                      <span className="text-gray-400 text-xs">{activeBrand.country}</span>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <a
                    href="#iletisim"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#iletisim')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-400 text-white text-xs font-black px-5 py-3 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <span>PARÇA SORGULA</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </a>
                  <button
                    onClick={() => setActiveId(null)}
                    className="w-10 h-10 flex items-center justify-center border border-gray-200 hover:border-gray-300 text-gray-400 hover:text-gray-700 transition-colors duration-200 cursor-pointer"
                  >
                    <i className="ri-close-line text-base"></i>
                  </button>
                </div>
              </div>

              {/* Parts grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2">
                {activeBrand.parts.map((part) => (
                  <div
                    key={part}
                    className="flex items-center gap-2.5 bg-gray-50 border border-gray-200 px-3 py-3 hover:border-orange-500/30 transition-colors duration-200"
                  >
                    <div className="w-5 h-5 flex items-center justify-center shrink-0">
                      <i className={`${partIcons[part] ?? 'ri-checkbox-circle-line'} text-orange-500 text-sm`}></i>
                    </div>
                    <span className="text-gray-700 text-xs font-semibold tracking-wide whitespace-nowrap">{part}</span>
                  </div>
                ))}
              </div>

              {/* Note */}
              <div className="mt-5 pt-4 border-t border-gray-100 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center shrink-0">
                  <i className="ri-information-line text-gray-400 text-xs"></i>
                </div>
                <span className="text-gray-400 text-xs">
                  Listede olmayan parçalar için de tedarik sağlıyoruz. Bize sorun.
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Hint */}
        {!activeBrand && (
          <div className="mt-px bg-white border border-gray-200 px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-cursor-line text-orange-500/60 text-sm"></i>
              </div>
              <span className="text-gray-500 text-sm">
                Parça gruplarını görmek için yukarıdan bir marka seçin.
              </span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 bg-orange-500/40 rounded-full"></div>
              <span className="text-gray-400 text-sm hidden sm:inline">
                Listede olmayan markalar için de parça tedariki yapıyoruz.
              </span>
              <a
                href="#iletisim"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#iletisim')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-orange-500 hover:text-orange-400 text-sm font-semibold flex items-center gap-1.5 cursor-pointer whitespace-nowrap"
              >
                <span>İletişime Geç</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
